"use client";

import { useEffect, useRef, type ReactNode } from "react";
import { scrollIntoViewMotionSafe } from "@/lib/motion";

export function FocusedRegion({
  label,
  block,
  children,
}: {
  label: string;
  block: ScrollLogicalPosition;
  children: ReactNode;
}) {
  const regionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const region = regionRef.current;
    if (!region) return;
    region.focus({ preventScroll: true });
    scrollIntoViewMotionSafe(region, { block });
  }, [block]);

  return (
    <section
      ref={regionRef}
      tabIndex={-1}
      aria-label={label}
      className="scroll-mt-20 outline-none"
    >
      {children}
    </section>
  );
}
